import * as THREE from 'three';
import {textLevel} from "../Text/TextLevel";

export class LineLevels {
    private group: THREE.Group = new THREE.Group();
    private snapValue: number = 0.55;

    constructor(
        scene: THREE.Scene,
        z: number,
        level: string,
		globalWidth: number
    ) {
        const thickness: number = 0.05;
        const length: number = 0.3;
        const size: number = 100.1;

        // Affichage du texte pour le niveau
        textLevel(scene, (z - 0.2), `Niveau ${level}`, globalWidth);

        // Création des segments de ligne pour le niveau
        for (let i: number = -size; i < size; i += 0.55) {
            const lineGeometry = new THREE.PlaneGeometry(length, thickness); // Longueur x Épaisseur
            const lineMaterial = new THREE.MeshBasicMaterial({ color: 0xB5B5C3, side: THREE.DoubleSide });

            const line = new THREE.Mesh(lineGeometry, lineMaterial);
            line.position.set(i, -.01, z);
            line.rotation.x = Math.PI / 2;

            this.group.add(line);
        }
        scene.add(this.group);
    }

    // Méthode pour repositionner le groupe en fonction de la position de la caméra
    public update(cameraPosition: THREE.Vector3): void {
        this.group.position.x = Math.floor(cameraPosition.x / this.snapValue) * this.snapValue;
    }

}
